/*
 * Project: LegalPlace assistant
 * File: src/components/option_container.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { generateId1, filterComponents } from './utils/misc';
import Option from './option';
import Variable from './variable';
import lpApp from '../app/lp_app';
import { checkIfAllFalse } from '../logic/utils/tree_operations';
// the flat import


export class _OptionContainer extends Component {
  constructor(props) {
    super(props);
    // initializing parameters
    this.params = {
      ...{
        lpKey: generateId1(4), // initialized by orgin
        parent: 'XXXX',
        variables: [],
        children: [],
        is_active: false,
      },
      ...props,
    };
    this.params.children = filterComponents(this.params.id);
    // console.log(this.params.children)
    // The creation must behere
    // test if it's a multiple with is_copy
  }

  componentWillMount() {
    if (this.props.isDuplicate) {
      this.props.initializeFlat(generateId1(4), this.props.parent, 'oc', this.props.sectionId, -2, this.props.lpParent);
    } else this.props.initializeFlat(this.props.lpKey, this.props.parent, 'oc', this.props.sectionId, -2, this.props.lpParent);
  }
  // PS. the option container contains his own lpKey, lpParent, id of the parent ,


  render() {
    // TODO: put the pre-render in their place
    const emptyChildren = (typeof this.params.children === 'undefined' || this.params.children.length === 0);

    // console.log(checkIfAllFalse(this.props.id.length ? this.props.id: []), this.props.id);

    return (!emptyChildren && <div key={`${this.params.id}_`} className="wzog-vars wz-multiple">
      { typeof this.props.children !== 'undefined' ? this.params.children.map(idx => (<Option
        key={generateId1(4)}
        lpKey={generateId1(4)}
        lpParent={this.params.lpParent}
        id={idx.length ? idx : lpApp.references.getOption(idx).meta.id}
        parent={this.props.id}
        type={idx.length ? 'RADIOS' : lpApp.references.getOption(idx).meta.type}
        label={idx.length ? '' : lpApp.references.getOption(idx).meta.label}
        variables={
          idx.length
            ? []
            : lpApp.references.getOption(idx).variables.map(
              index => lpApp.references.getVariable(index),
            )
        }
        awlad={idx.length
          ? []
          : lpApp.references.getOption(idx).children.map(
            index => lpApp.references.getOption(index).meta,
          )}
        is_multiple={false}
        isDuplicate={this.props.isDuplicate}
        copy={this.props.copy}
      />
      ), this) : <div />}
      {this.props.visibility ? this.params.variables.map(idx => (<Variable
        lpKey={this.props.lpKey}
        lpParent={this.props.lpParent}
        id={idx.id}
        parent={this.props.id}
        key={generateId1(2)}
        label={idx.label}
        type={idx.type}
        is_multiple={this.props.is_multiple}
        isDuplicate={this.props.isDuplicate}
        copy={this.props.copy}
      />), this) : <div />}
    </div>);
  }
}

// integrate onto the FLAT_UI system

const mapStateToProps = (state, ownProps) => ({
  sectionId: state.contract.currentSection,
  push_left: checkIfAllFalse(ownProps.id.length ? ownProps.id : []),
});

const mapDispatchToProps = () => ({
  // eslint-disable-next-line
  initializeFlat: (uiid, id, genre, sectionId, parentId, parentLp) => {},
});


export const OptionContainer = connect(mapStateToProps, mapDispatchToProps)(_OptionContainer);



// WEBPACK FOOTER //
// ./src/components/option_container.js